var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7822_1610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9664 11.6857C24.9664 11.5089 24.8218 11.3643 24.645 11.3643L21.9932 11.3763L17.9994 16.1375L14.0097 11.3803L11.3539 11.3683C11.1771 11.3683 11.0325 11.5089 11.0325 11.6897C11.0325 11.766 11.0606 11.8384 11.1088 11.8986L16.336 18.1263L11.1088 24.35C11.0603 24.4089 11.0333 24.4826 11.0325 24.5589C11.0325 24.7357 11.1771 24.8803 11.3539 24.8803L14.0097 24.8683L17.9994 20.1071L21.9892 24.8643L24.641 24.8763C24.8177 24.8763 24.9624 24.7357 24.9624 24.5549C24.9624 24.4785 24.9343 24.4062 24.886 24.346L19.6668 18.1223L24.8941 11.8946C24.9423 11.8384 24.9664 11.762 24.9664 11.6857Z",
    fill: "#EC5E59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 0.0400391C8.05982 0.0400391 0 8.09986 0 18.04C0 27.9802 8.05982 36.04 18 36.04C27.9402 36.04 36 27.9802 36 18.04C36 8.09986 27.9402 0.0400391 18 0.0400391ZM18 32.9865C9.74732 32.9865 3.05357 26.2927 3.05357 18.04C3.05357 9.78736 9.74732 3.09361 18 3.09361C26.2527 3.09361 32.9464 9.78736 32.9464 18.04C32.9464 26.2927 26.2527 32.9865 18 32.9865Z",
    fill: "#EC5E59"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7822_1610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon-error.eabcb91169e61051a7a94f41efd1220f.svg";
export { ForwardRef as ReactComponent };